var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_9596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.70617 0 0.399414 4.30684 0.399414 9.6007C0.399414 12.0293 1.30254 14.3345 2.94652 16.1134L2.41109 19.5643C2.3893 19.7049 2.44832 19.8458 2.56383 19.9289C2.62934 19.9761 2.70668 20 2.78441 20C2.84379 20 2.9034 19.9861 2.95812 19.9577L6.05348 18.3548C7.29664 18.9167 8.62332 19.2014 10 19.2014C15.2938 19.2014 19.6007 14.8946 19.6007 9.60074C19.6007 4.30684 15.2939 0 10 0ZM10 18.4457C8.67297 18.4457 7.39668 18.1588 6.20652 17.5928C6.09984 17.542 5.97551 17.5442 5.87055 17.5985L3.27195 18.9442L3.72156 16.0467C3.73965 15.9302 3.7023 15.812 3.6207 15.727C2.0307 14.0718 1.15504 11.8961 1.15504 9.60063C1.15504 4.72352 5.12289 0.755625 10 0.755625C14.8772 0.755625 18.8451 4.72348 18.8451 9.60066C18.8451 14.4779 14.8772 18.4457 10 18.4457Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.76172C8.8971 2.76172 7.99976 3.65906 7.99976 4.76204C7.99976 5.86501 8.8971 6.76235 10.0001 6.76235C11.1031 6.76235 12.0004 5.86501 12.0004 4.76204C12.0004 3.65899 11.103 2.76172 10.0001 2.76172ZM10.0001 6.00672C9.31374 6.00672 8.75538 5.44836 8.75538 4.76204C8.75538 4.07571 9.31374 3.51735 10.0001 3.51735C10.6864 3.51735 11.2447 4.07571 11.2447 4.76204C11.2447 5.44836 10.6864 6.00672 10.0001 6.00672Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2172 13.9742H11.787V7.77918C11.787 7.57051 11.6178 7.40137 11.4092 7.40137H7.78309C7.57441 7.40137 7.40527 7.57055 7.40527 7.77918V9.03476C7.40527 9.24343 7.57445 9.41257 7.78309 9.41257H8.21328V13.9742H7.78309C7.57441 13.9742 7.40527 14.1433 7.40527 14.352V15.6076C7.40527 15.8163 7.57445 15.9854 7.78309 15.9854H12.2172C12.4259 15.9854 12.595 15.8162 12.595 15.6076V14.352C12.595 14.1433 12.4258 13.9742 12.2172 13.9742ZM11.8393 15.2298H8.16082V14.7298H8.59102C8.79969 14.7298 8.96883 14.5606 8.96883 14.352V9.03476C8.96883 8.82609 8.79965 8.65695 8.59102 8.65695H8.16082V8.15703H11.0313V14.3521C11.0313 14.5607 11.2005 14.7299 11.4091 14.7299H11.8393V15.2298Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_132_9596",
    x1: -6.69441,
    y1: -11.0938,
    x2: 3.92222,
    y2: 22.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E20613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_132_9596",
    x1: 6.52175,
    y1: 0.542618,
    x2: 8.57541,
    y2: 7.25944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E20613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_132_9596",
    x1: 5.48794,
    y1: 2.6399,
    x2: 11.8346,
    y2: 15.1897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E20613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7B5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_9596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.69b882b2.svg";
export { ForwardRef as ReactComponent };